import { render, staticRenderFns } from "./GridCard.vue?vue&type=template&id=fe1a80d4"
import script from "./GridCard.vue?vue&type=script&lang=js"
export * from "./GridCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports